import { Skeleton } from "@mui/material";

export const dataTable = (data) => {
  const columns = [
    { field: "id", headerName: "#", flex: 0.3, minWidth: 57 },
    {
      field: "estado_badge",
      headerName: "Estado",
      renderCell: (p) => {
        return (
          <div className="d-flex justify-content-center w-100">
            <Skeleton variant="text" sx={{ fontSize: "16px" }} className="rounded w-100" />
          </div>
        );
      },
      minWidth: 76,
      flex: 0.4,
    },
    {
      field: "nombre",
      headerName: "Nombre",
      renderCell: (p) => {
        return (
          <div className="d-flex justify-content-center w-100">
            <Skeleton variant="text" sx={{ fontSize: "16px" }} className="rounded w-100" />
          </div>
        );
      },
      minWidth: 200,
      flex: 2,
    },
    {
      field: "boton",
      headerName: "Acciones",
      renderCell: (p) => {
        return (
          <div className="d-flex gap-3 align-items-center">
            <Skeleton variant="circular" height={24} width={24} />
            <Skeleton variant="circular" height={24} width={24} />
          </div>
        );
      },
      minWidth: 50,
      flex: 0.5,
    },
  ];

  const rows = data.map((d) => {
    return {
      id: d.id,
      estado_badge: d.estado.estado,
      estado: d.estado,
      nombre: d.nombre,
      boton: d.id,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      d.id?.toString().toLowerCase().includes(value) ||
      d.estado_badge?.toLowerCase().includes(value) ||
      d.nombre?.toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
